import { z } from "zod";

/**
 * 현장 정보 (실측: backend/app/api/v1/live/routes.py · services/live_service.py).
 *
 * 이 제품이 없애려는 것은 헛걸음이다. 대기 2시간인 줄 모르고 가는 것,
 * 품절인 줄 모르고 가는 것. 그래서 **언제 관측한 정보인지**가 값 자체만큼 중요하다.
 */
export const liveUpdateSchema = z.object({
  id: z.string(),
  placeId: z.string().nullable().optional(),
  eventId: z.string().nullable().optional(),
  reporterId: z.string().nullable().optional(),
  type: z.string(),
  value: z.record(z.unknown()).default({}),
  status: z.string(),
  observedAt: z.string(),
  expiresAt: z.string(),
  confirmedCount: z.number().default(0),
});
export type LiveUpdateDto = z.infer<typeof liveUpdateSchema>;
